import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import './ConfirmModal.css';
class ConfirmModal extends React.Component {
  from = '';
  item = {};
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    }
    this.toggle = this.toggle.bind(this);
  }

  toggle(modal) {
    this.setState(prevState => ({
      ...prevState,
      title: modal.title,
      message: modal.message,
      modal: !prevState.modal
    }));
  }

  closeModal(flag) {
    this.props.closeModal({ title: this.state.title, flag: flag });
    this.setState(prevState => ({
      ...prevState,
      modal: !prevState.modal
    }));
  }

  render() {
    const externalCloseBtn = <button className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={this.toggle}>&times;</button>;
    return (
      <>

        <Modal isOpen={this.state.modal} toggle={this.toggle} external={externalCloseBtn} 
        className={`${this.props.className} modal-md modal-lg custom-confirm-modal`}
         style={{ maxWidth: '1600px', width: '50% !important' }} backdrop={this.backdrop ? 'static' : 'nostatic'}>
          <div className="d-flex-column">
            <div className="confirm-modal-title-wrapp">
              <span className="confirm-modal-title">{this.state.title}</span>
            </div>
          </div>
          <ModalBody classNam="d-flex-column">
            <span className="confirm-modal-message">{this.state.message}</span>
          </ModalBody>

          <ModalFooter style={{ background: '#fff', border: 'none' }}>
            {/* <Button color="primary" onClick={this.toggle}>Do Something</Button>{' '} */}
            <span className="Skip-for-now" onClick={() => this.closeModal(false)}>Skip for now</span>
            &nbsp;&nbsp;&nbsp;
            <Button
              className="btn-pill action-button action-ob-button font-weight-bold"
              color="warning"
              style={{ paddingLeft: '20px', paddingRight: '20px' }}
              onClick={() => this.closeModal(true)}
            // disabled={!isFormValid}
            >
              Let’s Start
          </Button>
          </ModalFooter>
        </Modal>

      </>
    );
  }
}

export default ConfirmModal;

